import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const values = [
  {
    icon: "ri-speed-line",
    title: "Speed & Transparency",
    desc: "We move fast without cutting corners. You always know where your project stands, what's been done, and what comes next.",
  },
  {
    icon: "ri-focus-2-line",
    title: "Precision over Fluff",
    desc: "No bloated deliverables or vague reports. We deliver clean, effective solutions that directly address your business goals.",
  },
  {
    icon: "ri-team-line",
    title: "Full-Team Expertise",
    desc: "Developers, designers, marketers, PMs and QA engineers — all under one roof, working together toward your success.",
  },
  {
    icon: "ri-refresh-line",
    title: "End-to-End Ownership",
    desc: "We accompany your project from the first idea to post-launch growth, taking full responsibility for every stage.",
  },
];

export default function AboutUs() {
  return (
    <div className="min-h-screen font-sans" style={{ backgroundColor: "#FEF7EB" }}>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-24 px-6 md:px-16 overflow-hidden">
        <div
          className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full opacity-25 pointer-events-none"
          style={{ backgroundColor: "#E4D6EA", filter: "blur(80px)" }}
        />
        <div className="max-w-7xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-widest mb-4" style={{ color: "#0073E5" }}>
            About Us
          </p>
          <h1 className="text-5xl md:text-7xl font-bold text-black leading-tight max-w-3xl mb-8">
            We build software.<br />We grow businesses.
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
            London App Syndicate LTD is a UK-based IT company specialising in custom software development,
            IT consulting, and end-to-end digital marketing. We help businesses and individuals turn their
            ideas into powerful digital products — and then scale them.
          </p>
        </div>
      </section>

      {/* Image + Story */}
      <section className="px-6 md:px-16 pb-24">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="w-full h-[480px] rounded-2xl overflow-hidden flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=diverse%20tech%20team%20collaborating%20in%20a%20modern%20bright%20open%20office%20with%20laptops%20and%20whiteboards%20professional%20atmosphere%20warm%20light%20minimal%20background&width=900&height=600&seq=about-hero-01&orientation=landscape"
              alt="London App Syndicate team"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p>
              We are an IT company specialising in software development for businesses and individuals, as well as comprehensive turnkey digital solutions.
            </p>
            <p>
              Our expertise spans several key areas: custom software development, IT consulting, and digital marketing and advertising services. We help companies not only create tech products but also effectively bring them to market, attract users, and scale their business.
            </p>
            <p>
              We accompany projects at every stage — from idea and analytics to development, launch, and ongoing support. Thanks to our strong team of specialists, we combine technology and marketing into a unified growth strategy.
            </p>
            <p>
              Our projects involve experienced project managers, developers, UI/UX designers, marketers, and QA engineers. We value speed, transparency, and effectiveness — you always understand how your project is progressing and what results it is delivering.
            </p>
            <Link
              to="/contact-us"
              className="inline-flex items-center gap-2 font-semibold px-7 py-3.5 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap text-white text-sm mt-2"
              style={{ backgroundColor: "#0073E5" }}
              onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#005bbf")}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = "#0073E5")}
            >
              Work with us
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="px-6 md:px-16 py-24 rounded-3xl mx-4 md:mx-8 mb-16" style={{ backgroundColor: "#0073E5" }}>
        <div className="max-w-7xl mx-auto">
          <p className="text-xs font-semibold uppercase tracking-widest mb-4 text-white/60">
            Our Values
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-12 max-w-xl">
            What makes us different
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="rounded-2xl p-6" style={{ backgroundColor: "rgba(255,255,255,0.1)" }}>
                <div className="w-10 h-10 flex items-center justify-center rounded-full mb-4" style={{ backgroundColor: "#D4F419" }}>
                  <i className={`${v.icon} text-black text-lg`}></i>
                </div>
                <h3 className="text-white font-semibold text-base mb-2">{v.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  )
}
